<template>
    <div class="home">
        <div class="top-white-box"></div>
        <div>
            <DealDetails :dealId="(route.params.id as string)" />
        </div>
        <div class="top-gray-box">
            <h1>Other Deals You Might Like</h1>
        </div>
        <Deals :excludeDeal="Number(route.params.id)" :showJoinUs="true" :showPrice="true" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import Deals from "@/components/Deals.vue";
import DealDetails from "@/components/DealDetails.vue";
//import GiveawayBox from '@/components/GiveawayBox.vue';
import settings from '@/settings';
import { SettingsClass } from '@/settings';

export default defineComponent({
    name: "home",
    components: {
        Deals,
        DealDetails
        //GiveawayBox
    },
    setup() {
        const route = useRoute();
        const isParticipant = ref<boolean>(false);

        onMounted(() => {
            const cookie_lastref = document.cookie.split('; ').find(row => row.startsWith('MMD_ParticipantRefCode='))?.split('=')[1];
            if (cookie_lastref) {
                isParticipant.value = true;
            }
        });

        const settingsComputed = computed(() => settings as SettingsClass);

        return {
            route,
            isParticipant,
            settings: settingsComputed
        };
    }
});
</script>